import React from 'react';
import useAgentTasks from '../../../hooks/useAgentTasks';
import TaskHistoryTable from '../components/TaskHistoryTable';

function TaskHistoryTab({ agent }) {
  const { tasks, isLoading } = useAgentTasks(agent.id);

  return (
    <section className="tab-section">
      <header className="section-heading">
        <div>
          <h3>Task history</h3>
          <span>{isLoading ? 'Loading…' : `${tasks.length} recent tasks`}</span>
        </div>
      </header>
      <TaskHistoryTable isLoading={isLoading} tasks={tasks} />
    </section>
  );
}

export default TaskHistoryTab;
